'use strict';
import isDate from 'lodash/isDate';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import memoize from 'lodash/memoize';
import moment from 'moment';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';


/**
 * Supports custom, modal based input as well as browser input[type=date].
 * Normalizes input/output to Date class instances.
 *
 * TODO: need to force fallback to custom type when browser lacks full support for input[type=date].
 */
export class DatePickerView extends Component {
  static propTypes = {
    value: T.oneOfType([T.number, T.instanceOf(Date)]),
    onClick: T.func,
    onSelectDate: T.func,
    useNative: T.bool,
  };

  static HTML_DATE_FORMAT = 'YYYY-MM-DD';

  static PLACEHOLDER = '--/--/--';

  constructor(props) {
    super(props);
    this.handleBrowserInputChange = this.handleBrowserInputChange.bind(this);
  }

  handleBrowserInputChange(event) {
    if (isFunction(this.props.onSelectDate)) {
      const rawValue = event.target.value;
      if (isString(rawValue) && rawValue.length > 0) {
        const value = moment(rawValue, DatePickerView.HTML_DATE_FORMAT).toDate();
        this.props.onSelectDate(value);
      } else {
        this.props.onSelectDate(null);
      }
    }
  }

  render() {
    if (this.props.useNative) {
      return (
        <input
          className={classNames(this.props.className)}
          type='date'
          onChange={this.handleBrowserInputChange}
          value={DatePickerView.renderBrowserDate(this.props.value)}
        />
      );
    } else {
      return (
        <span
          className={classNames(this.props.className)}
          onClick={this.props.onClick}
        >
        {DatePickerView.formatDate(this.props.value)}
      </span>
      );
    }
  }

  static formatDate = memoize(date =>
    isNumber(date) || isDate(date) ? moment(date).format('M/D/YY') : DatePickerView.PLACEHOLDER
  );

  static renderBrowserDate = memoize(date =>
    isNumber(date) || isDate(date) ? moment(date).format(DatePickerView.HTML_DATE_FORMAT) : ''
  );
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/components/DatePicker/DatePickerView.js